import { InteractionType, LogLevel } from '@azure/msal-browser'

export const clientId: string = import.meta.env.VITE_AZURE_CLIENT_ID
export const authority: string = import.meta.env.VITE_AZURE_AUTHORITY
export const scopesExtranetApi: Array<string> = import.meta.env.VITE_SCOPES_API.split(',')
export const cacheLocation: string = import.meta.env.VITE_AZURE_CACHE_LOCATION
export const interactionType: InteractionType = import.meta.env.VITE_AZURE_INTERACTION_TYPE ?? InteractionType.Redirect
export const logLevel: LogLevel =
  import.meta.env.VITE_AZURE_LOG_LEVEL_VERBOSE == true ? LogLevel.Verbose : LogLevel.Warning
export const aktoTenantId = import.meta.env.VITE_AZURE_TENANT_ID_INTERNES
export const logoutUri = import.meta.env.VITE_AZURE_LOGOUT_URI
